module.exports = __webpack_public_path__ + "static/media/IlotE_synthese_2.57ad6885.webp";